import type { enStokCounts } from '../en/stok-counts';

export const idStokCounts: Record<keyof typeof enStokCounts, string> = {
  // ---- Status ---------------------------------------------------------------------------
  'stok.countStatus.planned': 'Direncanakan',
  'stok.countStatus.in_progress': 'Sedang dihitung',
  'stok.countStatus.recount': 'Hitung ulang',
  'stok.countStatus.submitted': 'Menunggu persetujuan',
  'stok.countStatus.approved': 'Disetujui',
  'stok.countStatus.rejected': 'Ditolak',
  'stok.countStatus.posted': 'Diposting',
  'stok.countStatus.cancelled': 'Dibatalkan',

  // ---- Daftar ---------------------------------------------------------------------------
  'stok.counts.title': 'Stok opname',
  'stok.counts.subtitle':
    'Hitung fisik stok {branch}, dibandingkan dengan buku stok pada batas waktu.',
  'stok.counts.plan': 'Rencanakan opname',
  'stok.counts.planReadOnly':
    'Anda bisa melihat opname. Merencanakan opname butuh izin penyesuaian stok.',
  'stok.counts.listTitle': 'Daftar opname',
  'stok.counts.listDesc': 'Terbaru di atas. Progres dan akurasi tampil jika Anda boleh melihatnya.',
  'stok.counts.allStatuses': 'Semua status',
  'stok.counts.listSearch': 'Nomor atau lokasi',
  'stok.counts.empty': 'Belum ada stok opname — rencanakan yang pertama.',
  'stok.counts.emptyReadOnly':
    'Belum ada stok opname. Opname muncul di sini setelah manajer merencanakannya.',
  'stok.counts.emptyStatus': 'Tidak ada opname dengan status “{status}”.',
  'stok.counts.colNumber': 'Nomor',
  'stok.counts.colProgress': 'Dihitung',
  'stok.counts.progressShort': '{counted} dari {lines}',
  'stok.counts.accuracyOf': '{within} dari {counted} baris',

  // ---- Rincian --------------------------------------------------------------------------
  'stok.counts.type': 'Jenis opname',
  'stok.counts.typeFull': 'Opname penuh',
  'stok.counts.typeCycle': 'Opname bergilir',
  'stok.counts.typeFullHint':
    'Semua barang aktif di lokasi, dan setiap lot yang masih ada stoknya.',
  'stok.counts.typeCycleHint': 'Hanya barang yang dipilih dan/atau satu kategori.',
  'stok.counts.scope': 'Cakupan',
  'stok.counts.scopeCategory': 'Kategori {category}',
  'stok.counts.scopeItems': '{count} barang',
  'stok.counts.blind': 'Hitung buta',
  'stok.counts.blindYes': 'Tanpa jumlah sistem',
  'stok.counts.blindNo': 'Jumlah sistem ditampilkan',
  'stok.counts.tolerance': 'Toleransi',
  'stok.counts.plannedDate': 'Tanggal rencana',
  'stok.counts.cutoff': 'Batas waktu (cutoff)',
  'stok.counts.cutoffNotYet': 'Ditetapkan saat mulai hitung',
  'stok.counts.round': 'Putaran hitung',
  'stok.counts.notes': 'Catatan',
  'stok.counts.createdBy': 'Direncanakan oleh',
  'stok.counts.startedBy': 'Dimulai oleh',
  'stok.counts.submittedBy': 'Dikirim oleh',
  'stok.counts.decidedBy': 'Diputuskan oleh',
  'stok.counts.decisionNote': 'Catatan keputusan',
  'stok.counts.postedBy': 'Diposting oleh',
  'stok.counts.byAt': '{name}, {time}',
  'stok.counts.factsTitle': 'Rincian opname',
  'stok.counts.lineWithLot': '{item} · lot {lot}',
  'stok.counts.lotLabel': 'Lot {lot}',

  // ---- Rencana --------------------------------------------------------------------------
  'stok.counts.backToList': 'Stok opname',
  'stok.counts.planTitle': 'Rencanakan stok opname',
  'stok.counts.planSubtitle': 'Satu lokasi di {branch}. Penghitungan dimulai nanti, di tablet.',
  'stok.counts.planNoPermission': 'Minta manajer untuk merencanakan opname.',
  'stok.counts.noLocations': 'Belum ada lokasi stok aktif — buat dulu.',
  'stok.counts.planScopeTitle': 'Lokasi dan cakupan',
  'stok.counts.planScopeDesc': 'Pilih tempat yang dihitung dan barangnya.',
  'stok.counts.categoryHint':
    'Semua barang dalam kategori ini ikut dihitung, selain barang yang dipilih.',
  'stok.counts.noCategory': 'Tanpa kategori',
  'stok.counts.itemsLabel': 'Barang',
  'stok.counts.itemsSelected': '({count} dipilih)',
  'stok.counts.itemSearch': 'Cari barang',
  'stok.counts.clearItems': 'Kosongkan pilihan',
  'stok.counts.noItemMatch': 'Tidak ada barang yang cocok dengan “{query}”.',
  'stok.counts.planRulesTitle': 'Aturan hitung',
  'stok.counts.planRulesDesc': 'Baris di luar toleransi dihitung ulang sebelum disetujui.',
  'stok.counts.blindLabel': 'Hitung tanpa jumlah sistem (buta)',
  'stok.counts.blindHint':
    'Penghitung tidak pernah melihat jumlah sistem maupun selisihnya; hanya penyetuju. Disarankan.',
  'stok.counts.tolerancePercent': 'Toleransi (%)',
  'stok.counts.toleranceHint': 'Selisih yang diizinkan terhadap jumlah sistem, mis. 5 atau 2,5.',
  'stok.counts.toleranceValue': 'Toleransi nilai ({currency})',
  'stok.counts.toleranceValueHint':
    'Juga diizinkan jika nilai selisihnya paling banyak sebesar ini.',
  'stok.counts.planNote': 'Stok baru berubah setelah opname disetujui dan diposting.',
  'stok.counts.planSubmit': 'Rencanakan',
  'stok.counts.created': 'Opname {number} direncanakan.',
  'stok.counts.err.location': 'Pilih lokasi.',
  'stok.counts.err.tolerance': 'Isi persentase 0 sampai 100 (paling banyak dua desimal).',
  'stok.counts.err.toleranceValue': 'Isi jumlah bulat.',
  'stok.counts.err.scope': 'Pilih barang atau kategori untuk opname bergilir.',
  'stok.counts.err.tooManyItems': 'Pilih paling banyak {max} barang.',

  // ---- Rincian: rencana / batal ---------------------------------------------------------
  'stok.counts.detailTitle': 'Stok opname {number}',
  'stok.counts.plannedTitle': 'Siap dihitung',
  'stok.counts.plannedDesc': 'Mulai saat tim penghitung sudah di lokasi.',
  'stok.counts.start': 'Mulai hitung',
  'stok.counts.starting': 'Memulai…',
  'stok.counts.startReadOnly': 'Memulai opname butuh izin hitung stok.',
  'stok.counts.startTitle': 'Mulai hitung sekarang?',
  'stok.counts.startBody':
    'Memulai menetapkan batas waktu (cutoff) saat ini: jumlah sistem adalah semua mutasi yang diposting sampai sekarang. Layanan tetap berjalan — penjualan dan penerimaan setelah cutoff diperhitungkan saat opname dikirim.',
  'stok.counts.startBlind': 'Penghitung tidak akan melihat jumlah sistem.',
  'stok.counts.started': 'Penghitungan dimulai. Cutoff sudah ditetapkan.',
  'stok.counts.emptyScope':
    'Tidak ada yang dihitung dalam cakupan ini — tidak ada barang atau stok di lokasi ini.',
  'stok.counts.cancel': 'Batalkan opname',
  'stok.counts.cancelling': 'Membatalkan…',
  'stok.counts.keepCount': 'Jangan batalkan',
  'stok.counts.cancelTitle': 'Batalkan opname {number}?',
  'stok.counts.cancelBody': 'Hitungan yang sudah diisi tetap tercatat, tetapi stok tidak berubah.',
  'stok.counts.cancelled': 'Opname dibatalkan.',
  'stok.counts.cancelledTitle': 'Opname dibatalkan',
  'stok.counts.cancelledDesc': 'Opname ini dihentikan tanpa mengubah stok.',
  'stok.counts.leftoverDrafts':
    'Masih ada {count} isian yang belum disimpan di perangkat ini, tetapi opname sudah tidak bisa diubah.',
  'stok.counts.discardDrafts': 'Buang isian',

  // ---- Lembar hitung --------------------------------------------------------------------
  'stok.counts.workspaceTitle': 'Hitung',
  'stok.counts.workspaceRecountTitle': 'Hitung ulang',
  'stok.counts.cutoffNote': 'Cutoff {time}. Mutasi setelahnya diperhitungkan saat opname dikirim.',
  'stok.counts.blindNote':
    'Hitung apa yang ada secara fisik. Jumlah sistem dan selisih hanya terlihat oleh penyetuju.',
  'stok.counts.expectedVisibleNote':
    'Jumlah sistem saat cutoff ditampilkan karena Anda boleh menyetujui opname.',
  'stok.counts.draftNote': 'Isian disimpan di perangkat ini sampai server mengonfirmasinya.',
  'stok.counts.countReadOnly':
    'Anda bisa melihat opname ini. Mengisi hitungan butuh izin hitung stok.',
  'stok.counts.recountBannerTitle': 'Hitung ulang — putaran {round}',
  'stok.counts.recountBannerBody':
    'Hanya {count} baris yang ditandai yang bisa diubah. Hitung lagi; hitungan pertama tetap disimpan untuk penyetuju.',
  'stok.counts.approverNote': 'Catatan penyetuju: {note}',
  'stok.counts.searchLines': 'Cari baris',
  'stok.counts.searchPlaceholder': 'Nama, SKU atau lot — Enter langsung ke barisnya',
  'stok.counts.filterLabel': 'Tampilkan baris',
  'stok.counts.filterAll': 'Semua',
  'stok.counts.filterTodo': 'Belum dihitung ({count})',
  'stok.counts.filterUnsaved': 'Belum disimpan ({count})',
  'stok.counts.linesLabel': 'Baris hitung',
  'stok.counts.noLineMatch': 'Tidak ada baris yang cocok dengan “{query}”.',
  'stok.counts.noLinesInFilter': 'Tidak ada baris di tampilan ini.',
  'stok.counts.qtyLabel': 'Jumlah dihitung',
  'stok.counts.qtyInputLabel': 'Jumlah dihitung: {item} ({unit})',
  'stok.counts.savedCount': 'Tersimpan: {qty} · {name}',
  'stok.counts.previousCount': 'Hitungan sebelumnya: {qty} · {name}',
  'stok.counts.firstCount': 'Hitungan pertama: {qty}',
  'stok.counts.expectedAtCutoff': 'Jumlah sistem saat cutoff: {qty}',
  'stok.counts.lockedHint': 'Terkunci: putaran ini hanya menghitung ulang baris yang ditandai.',
  'stok.counts.recountFlag': 'Hitung ulang',
  'stok.counts.state.locked': 'Terkunci',
  'stok.counts.state.conflict': 'Konflik',
  'stok.counts.state.invalid': 'Angka tidak valid',
  'stok.counts.state.dirty': 'Belum disimpan',
  'stok.counts.state.counted': 'Tersimpan',
  'stok.counts.state.uncounted': 'Belum dihitung',
  'stok.counts.uncountedLine': 'Belum dihitung — isi 0 jika barangnya tidak ada.',
  'stok.counts.invalidLine': 'Isi jumlah dalam {unit}, mis. 2,5.',
  'stok.counts.conflictTitle': 'Diubah di perangkat lain',
  'stok.counts.conflictServer': 'Server: {qty} · {name}',
  'stok.counts.conflictServerNone': 'Server: belum dihitung',
  'stok.counts.conflictMine': 'Isian Anda: {qty}',
  'stok.counts.keepMine': 'Pakai nilai saya',
  'stok.counts.useServer': 'Pakai nilai server',
  'stok.counts.conflictNotice':
    'Ada baris yang diubah di perangkat lain ({count}). Pilih nilai yang dipakai di tiap baris; isian Anda yang lain belum tersimpan — simpan lagi.',
  'stok.counts.uncountedNotice':
    '{count} baris belum dihitung. Hitung dulu (isi 0 jika tidak ada), simpan, lalu kirim.',
  'stok.counts.invalidNotice': '{count} isian bukan angka yang valid dan tidak disimpan.',
  'stok.counts.refusedNotice':
    'Server menolak {count} isian — lihat baris yang ditandai. Tidak ada isian dari kiriman itu yang tersimpan.',
  'stok.counts.progress': 'Dihitung {done} dari {total} · sisa {remaining}',
  'stok.counts.progressRecount': 'Dihitung ulang {done} dari {total} · sisa {remaining}',
  'stok.counts.unsaved': 'Belum disimpan: {count}',
  'stok.counts.allSaved': 'Semua isian tersimpan',
  'stok.counts.save': 'Simpan',
  'stok.counts.saved': '{count} isian tersimpan.',
  'stok.counts.submit': 'Kirim hitungan',
  'stok.counts.submitBlocked': 'Simpan semua isian dan selesaikan konflik sebelum mengirim.',
  'stok.counts.submitTitle': 'Kirim hitungan?',
  'stok.counts.submitBody':
    '{count} baris dibandingkan dengan buku stok pada cutoff. Baris di luar toleransi dikembalikan untuk dihitung ulang; setelah itu opname diteruskan ke penyetuju.',
  'stok.counts.submitBodyRecount':
    'Hitung ulang dibandingkan dengan buku stok lalu diteruskan ke penyetuju, berapa pun selisihnya.',
  'stok.counts.submitRemaining': '{count} baris belum dihitung — server akan menolak.',
  'stok.counts.submitRemainingRecount':
    '{count} baris yang ditandai belum dihitung ulang — hitungan pertamanya yang dipakai.',
  'stok.counts.submitConfirm': 'Kirim',
  'stok.counts.submitting': 'Mengirim…',
  'stok.counts.submittedOk': 'Hitungan dikirim untuk disetujui.',
  'stok.counts.submittedRecount': 'Ada baris di luar toleransi — hitung ulang baris yang ditandai.',

  // ---- Pemeriksaan / keputusan ----------------------------------------------------------
  'stok.counts.waitingTitle': 'Menunggu persetujuan',
  'stok.counts.waitingDesc':
    'Hitungan sudah dikirim. Selisih tetap tersembunyi dari penghitung sampai penyetuju memutuskan.',
  'stok.counts.statLines': 'Baris',
  'stok.counts.statLinesDesc': 'Barang dan lot di lembar hitung.',
  'stok.counts.statCounted': 'Dihitung',
  'stok.counts.statCountedDesc': 'Baris yang sudah ada hitungannya.',
  'stok.counts.statWithin': 'Dalam toleransi',
  'stok.counts.statWithinDesc': 'Baris terhitung yang masih dalam toleransi.',
  'stok.counts.statAccuracy': 'Akurasi',
  'stok.counts.statAccuracyDesc': 'Dalam toleransi ÷ baris terhitung.',
  'stok.counts.statVariance': 'Total selisih',
  'stok.counts.statVarianceDesc': 'Nilai pada biaya rata-rata (+ lebih, − kurang).',
  'stok.counts.reviewTitle': 'Selisih per baris',
  'stok.counts.reviewDesc':
    'Selisih = dihitung − (jumlah sistem saat cutoff + mutasi sampai baris itu dihitung).',
  'stok.counts.outsideOnly': 'Hanya di luar toleransi',
  'stok.counts.noOutside': 'Semua baris dalam toleransi.',
  'stok.counts.select': 'Pilih',
  'stok.counts.selectLine': 'Pilih {item}',
  'stok.counts.colExpected': 'Sistem saat cutoff',
  'stok.counts.colMovedAfter': 'Mutasi setelah cutoff',
  'stok.counts.colCounted': 'Dihitung',
  'stok.counts.colVarianceQty': 'Selisih',
  'stok.counts.colVarianceValue': 'Nilai selisih',
  'stok.counts.colTolerance': 'Toleransi',
  'stok.counts.within': 'Dalam toleransi',
  'stok.counts.outside': 'Di luar toleransi',
  'stok.counts.recounted': 'Sudah dihitung ulang',
  'stok.counts.noCost': 'Tanpa biaya rata-rata',
  'stok.counts.sodTitle': 'Orang lain harus memutuskan',
  'stok.counts.sodBody':
    'Anda ikut menghitung; orang lain harus menyetujui atau menolak (pemisahan tugas). Anda masih bisa meminta hitung ulang.',
  'stok.counts.decideReadOnly': 'Menyetujui atau menolak butuh izin persetujuan stok.',
  'stok.counts.requestRecount': 'Minta hitung ulang ({count})',
  'stok.counts.recountTitle': 'Minta hitung ulang?',
  'stok.counts.recountBody':
    '{count} baris yang dipilih dikembalikan ke penghitung; baris lainnya dikunci.',
  'stok.counts.recountNote': 'Catatan untuk penghitung',
  'stok.counts.recountConfirm': 'Minta hitung ulang',
  'stok.counts.recountRequested': 'Hitung ulang diminta.',
  'stok.counts.approve': 'Setujui',
  'stok.counts.approveTitle': 'Setujui opname?',
  'stok.counts.approveBody':
    '{count} baris yang berselisih akan menjadi penyesuaian stok setelah opname diposting.',
  'stok.counts.decisionNoteLabel': 'Catatan',
  'stok.counts.selfDecisionNote': 'Alasan (wajib — Anda sendiri yang menghitung stok ini)',
  'stok.counts.approved': 'Opname disetujui.',
  'stok.counts.reject': 'Tolak',
  'stok.counts.rejectTitle': 'Tolak opname?',
  'stok.counts.rejectBody': 'Stok tidak berubah. Jelaskan alasannya agar tim bisa menghitung lagi.',
  'stok.counts.rejectNote': 'Alasan',
  'stok.counts.rejected': 'Opname ditolak.',
  'stok.counts.decisionTitle': 'Keputusan',
  'stok.counts.approvedDesc': 'Disetujui — posting untuk menerapkan selisih ke stok.',
  'stok.counts.rejectedDesc': 'Ditolak — stok tidak berubah.',
  'stok.counts.postedSummary':
    'Diposting — selisih sudah diterapkan ke stok sebagai mutasi opname.',
  'stok.counts.post': 'Posting penyesuaian',
  'stok.counts.posting': 'Memposting…',
  'stok.counts.postReadOnly': 'Posting butuh izin penyesuaian atau persetujuan stok.',
  'stok.counts.postTitle': 'Posting opname?',
  'stok.counts.postBody': '{count} penyesuaian akan diposting ke buku stok pada biaya rata-rata.',
  'stok.counts.postWarning': 'Posting mengubah stok dan hanya bisa dikoreksi dengan mutasi baru.',
  'stok.counts.postedToast': '{count} penyesuaian diposting.',
  'stok.counts.postedTitle': 'Penyesuaian diposting',
  'stok.counts.postedDesc': 'Mutasi opname yang ditulis ke buku stok.',
  'stok.counts.postedNone': 'Tidak ada selisih — tidak ada yang perlu diposting.',
  'stok.counts.postedTotal': 'Total',
  'stok.counts.viewLedger': 'Lihat mutasi',
};
